import React, { useEffect } from "react";
import { Severity } from "@eveworld/types";
import { useNotification, useSmartObject } from "@eveworld/contexts";

import { ErrorNotice, ErrorNoticeTypes } from "@eveworld/ui-components";

import { JSX } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import SidebarAdmin from "./SidebarAdmin";
import InitVars from "../../src/InitVars";
import AdminPlayerList from "./admin/AdminPlayerList";
import Map3D from "./map/Map3D";

// React.memo
const Admin = React.memo(
  () //   {
  : JSX.Element => {
    const { smartCharacter, loading } = useSmartObject();
    const { notify, handleClose } = useNotification();

    const sidebar = React.useMemo(() => <SidebarAdmin />, []);

    //const { worldContract } = useWorldContract();

    useEffect(() => {
      if (loading) {
        notify({ type: Severity.Info, message: "Loading..." });
      } else {
        handleClose();
      }
    }, [loading]);

    if ((!loading && !smartCharacter) || !smartCharacter?.isSmartCharacter) {
      return (
        <ErrorNotice
          type={ErrorNoticeTypes.MESSAGE}
          errorMessage="Unknown Character"
        />
      );
    }

    if (
      smartCharacter.corpId == "98000002" &&
      (smartCharacter.address == "0xb5b66ffff966f4f648335a14c84418654c43d55c" || //Tapticc
        smartCharacter.address == "0xdf111948c5e06e90fe41ce3d989e6b57d18d49a4") //Scetrov
    ) {
      //Reapers corp id
      return (
        <>
          <div className="container">
            {/* <SideBar /> */}
            {sidebar}
            <Box
              sx={{
                height: "94vh",
                paddingLeft: 1,
              }}
            >
              <div className="grid">
                {InitVars.sidebarOption == "" && (
                  <p>Welcome {smartCharacter.name} to the Admin page</p>
                )}
                {InitVars.sidebarOption == "AdminPlayerList" && (
                  <AdminPlayerList
                    smartCharacterAddress={smartCharacter.address}
                  ></AdminPlayerList>
                )}
                {/* <Map3D></Map3D> */}
              </div>
            </Box>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="container">
            <Box
              sx={{
                height: "94vh",
                paddingLeft: 1,
              }}
            >
              <div className="grid">
                <p>
                  Welcome {smartCharacter.name}, you are not a member of Reapers
                  Admin sorry
                </p>
              </div>
            </Box>
          </div>
        </>
      );
    }
  }
);

export default React.memo(Admin);
